export default [
  // City College
  {
    id: 'sg1',
    purchaserId: '10003',
    action: 'CREATE_NEW_RECORD',
    name: 'Science Department',
    groupType: 'REGISTRATION',
    teacherCount: 18,
    studentCount: 0,
    hasBeenReviewed: false,
  },
  {
    id: 'sg2',
    purchaserId: '10003',
    action: 'DO_NOT_SYNC',
    name: 'Arts & Humanities',
    groupType: 'REGISTRATION',
    teacherCount: 32,
    studentCount: 5,
    hasBeenReviewed: true,
  },
  {
    id: 'sg3',
    purchaserId: '10003',
    action: 'DO_NOT_SYNC',
    name: 'Student Council 2024',
    groupType: 'YEAR',
    teacherCount: 4,
    studentCount: 20,
    hasBeenReviewed: false,
  },
];
